import React from "react";
import { createRoot } from "react-dom/client";
import FocalPointProductList, {
  FocalPointData,
} from "../../components/focal-point-product-list"; // Adjust the import path if necessary

// Handler function to find the element and render the React component
export default async function handleFocalPointProductList(
  element: HTMLElement,
) {
  const orgId = window.helium.brandData.orgId;
  const productHandle = window.location.pathname.split("/").at(-1);
  const data = await fetch(
    `https://cdn.heliumbuilder.com/${orgId}/products/${productHandle}/focal-point-recommendations.json`,
  );

  const res = (await data.json()) as FocalPointData;
  if (res.focalPoints.length === 0) {
    return;
  }

  const root = createRoot(element); // Use createRoot for modern React
  root.render(
    <React.StrictMode>
      <FocalPointProductList focalData={res} />
    </React.StrictMode>,
  );
}
